module.exports = __webpack_public_path__ + "static/media/news-hero.576e3fa7.png";